<template>
  <div v-loading="loading"
       element-loading-text="拼命加载中"
       class="picklist"
  >
    <h3 style="text-align: center;margin-bottom: 10px">{{ partition_name }} 区拣货列表</h3>

    <el-row :gutter="12">
      <template v-for="(item,index) of pick_list">
        <transition name="el-zoom-in-center" :key="item.id">
          <el-col :span="24" v-show="showGroup[index]">
            <el-card shadow="always" style="" @click.native="pickingUp(item,index)">
              <div>{{ item.shelf_no }}</div>
              <div>{{ item.order_number }}</div>
              <div style="color:#3967FF;">
                国家：
                <span v-if=" item.purchase_detail && item.purchase_detail.sub_table && item.purchase_detail.sub_table.country !=null ">
                  {{ item.purchase_detail.sub_table.country }}
                </span>
                <span v-else> 无 </span>
              </div>
            </el-card>
          </el-col>
        </transition>
      </template>
    </el-row>

    <div v-if="display" @click="generate" style="text-align: center;margin-top: 200px"> <el-button type="primary">生成拣货列表</el-button></div>

    <el-dialog
      :title="'货架  '+listInfo.shelf_no"
      :visible.sync="centerDialogVisible"
      width="95%"
      top="1vh"
      :close-on-click-modal="false"
      :before-close="cancelDialog"
      center>
      <div style="margin-bottom: 20px;text-align: center;font-size: 16px">订单编号 {{ listInfo.order_number }}</div>
      <!--<span slot="footer" class="dialog-footer">-->
      <el-form class="search-box" ref="shelfForm" :model="shelfForm" :rules="rules">
        <el-form-item prop="shelf_number">
          <el-input
            ref="shelfSearch"
            @focus="stopKeyborad"
            @blur="stopKeyborad"
            v-model="shelfForm.shelf_number"
            @keydown.enter.native.prevent="doPickUp()"
            :placeholder="'扫描货架条码 '+listInfo.shelf_no"
          >
            <el-button
              @click.prevent="doPickUp()"
              slot="append"
              icon="el-icon-search"
            ></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="order_items">
        <template v-for="item of items">
          <div class="show" :key="item.id" >
            <div class="line">
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple"
                       style="color: #bd2c00">
                    <h3>产品名称</h3>
                    <p>{{ item.product_name }}</p>
<!--                    <h3>货架号: </h3>
                    <p>{{ item.shelf.shelf_no }}</p>-->
                    <h3>多品编号</h3>
                    <p>{{ item.transaction_number }}</p>
                    <h3 style="margin-top: 20px">数量</h3>
                    <p style="color: #bd2c00">{{ item.quantity }}</p>
                  </div>
                </el-col>
                <el-col :span="12">
                  <img style="width: 100%;" :src="item.image_url" alt="" preview="1" preview-text='图片展示'/>
                </el-col>
              </el-row>
            </div>
          </div>
        </template>
      </div>
      <!--</span>-->
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "PickList",
  data() {
    return {
      loading: true,
      centerDialogVisible: false,
      partition_id: 0,
      partition_name: "",
      pick_list: [],

      index: undefined,
      listInfo: {},
      items:{},

      showGroup: [],

      shelfForm: {
        shelf_number: ""
      },
      rules: {
        shelf_number: [
          {required: true, message: "请扫描货架条码", trigger: "blur"},
          /*{
            type: "number",
            message: "请输入正确的订单编号",
            trigger: ["blur", "change"],
          },*/
        ],
      },
    }
  },
  methods: {
    pickingUp(item, index) {
      this.listInfo = item
      this.index = index
      this.http.fetchGet(this.api.getDetail,{'order_number':item.order_number,'shelf_id':item.shelf_id}).then((res) => {
        var data = res.data;
        if (data.code === 200) {
          this.items = res.data.data;
          this.centerDialogVisible = true

          //加定时器
          this.$nextTick(() => {
            this.shelfOnfocusEvent()
          })
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    doPickUp() {

      if (this.shelfForm.shelf_number !== this.listInfo.shelf_no) {
        this.$message.error(this.shelfForm.shelf_number+' 与拣货货架编号不一致')
        this.shelfOnfocusEvent()
        this.shelfForm.shelf_number = ""
        return false
      }

      this.$refs.shelfForm.validate((valid) => {
        if (valid) {
          this.http.fetchDel(this.api.pickUp + "/" + this.listInfo.id).then((res) => {
            console.log(res)

            var data = res.data;
            if (data.code === 200) {

              this.$set(this.showGroup, this.index, false)
              // console.log(this.showGroup)
              const h = this.$createElement;
              this.$message({
                offset: 0,
                duration: 3000,
                message: h('p', null, [
                  h('span', null, '拣货成功 '),
                  // h('i', { style: 'color: teal' }, 'VNode')
                ])
              });

            }

            this.centerDialogVisible = false
            this.shelfForm.shelf_number = ""

          }).catch((err) => {
            console.log(err);
            this.shelfForm.shelf_number = ''
            this.shelfOnfocusEvent()
            this.$message.error('扫描货架号错误');
          });
        } else {
          // this.$message.error('请输入账号和密码');
          console.log("error submit!!");
          return false;
        }
      });

    },
    getPickList() {
      this.http.fetchGet(this.api.getPickList + "/" + this.partition_id).then((res) => {
        console.log(res)
        let data = res.data
        if (data.code === 200) {
          this.loading=false
          this.pick_list = data.data

          let arr3 = [];
          for (let i = 0; i < this.pick_list.length; i++) {
            arr3[i] = true
          }

          this.showGroup = arr3
          // console.log(this.showGroup)

        }
      }).catch(err => {
        console.log(err)
      })
    },

    //生成拣货列表
    generate(){
      this.loading=true
        this.http.fetchPost(this.api.generatePickingList+"/"+this.partition_id).then((res)=>{
          let data=res.data

          if (data.code === 200) {
            this.getPickList()
          }else {
            const h = this.$createElement;
            this.$message({
              offset: 10,
              duration: 3000,
              message: h('p', null, [
                h('span', null, '暂时没有需要拣货的产品'),
                // h('i', { style: 'color: teal' }, 'VNode')
              ])
            });
          }

          this.loading=false
          // console.log(res)

        }).catch((err)=>{
          console.log(err)
          this.loading=false
        })
    },

    cancelDialog() {
      this.centerDialogVisible = false
      setTimeout(() => {
        this.shelfForm.shelf_number = ''
        this.listInfo = {}
      },300)
    },

    //扫描货架自动获取光标
    shelfOnfocusEvent() {
      this.$refs.shelfSearch.focus()
    },
    stopKeyborad(e) {
      //尝试一下
      e.target.setAttribute('readonly', true);
      setTimeout(() => {
        e.target.removeAttribute('readonly');
      }, 100);
    },
  },
  mounted() {
    console.log(this.$route.query)
    this.partition_id = this.$route.query.p
    this.partition_name = this.$route.query.n
    this.getPickList()
  },
  computed:{
    display(){

      for (let i = 0; i <this.showGroup.length; i++) {
        if (this.showGroup[i] === true) {
          return false
        }
      }
      return true
    }
  }


}
</script>
<style>
.pswp--open{
  z-index:2008!important
}
/* Webkit浏览器（Chrome、Safari等） */
.order_items::-webkit-scrollbar {
  width: 6px; /* 滚动条宽度 */
}

.order_items::-webkit-scrollbar-track {
  background: #ffffff; /* 滚动条背景色 */
}

.order_items::-webkit-scrollbar-thumb {
  background-color: #064edd; /* 滚动条前景色 */
}
/* 让滚动条一直显示 */
.order_items::-webkit-scrollbar {
  display: block !important;
}
</style>
<style scoped lang="stylus">

.order_items{
  height: 355px;
  overflow-y scroll
  //border #8c939d 1px solid
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin; /* 设置滚动条宽度 */
  scrollbar-color: #000000 #ffffff; /* 设置滚动条颜色 */
}
.el-col
  margin-bottom 10px
.show {
  //float: left;
  width: 98%;

  .line {
    box-sizing: border-box;
    border: 1px solid black;
    //margin-top: 1rem;
    margin: 1px;
    //float: left;
    width: 99%;

    .el-col {
      margin-top 5px
      margin-bottom: 5px;
      padding 0 5px

      &:last-child {
        //margin-bottom: 0;
      }
    }

    .grid-content {
      //text-align center

      h3 {
        font-size 14px
      }
    }

  }
}

.picklist >>> .el-dialog--center .el-dialog__body {
  padding: 0 25px 15px;
}
</style>
